<template>
  <tr v-if="show">
    <td colspan="14">
      <table class="slds-table slds-no-row-hover" :key="`offer_${index}`" v-if="offer.itemsList.length">
        <thead>
          <tr scope="col">
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.status')">{{$t('campaignDesigner.contentSelectionAndTag.status')}}</div>
            </th>
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.itemTypeDescription')">{{$t('campaignDesigner.contentSelectionAndTag.itemTypeDescription')}}</div>
            </th>
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.itemDescription')">{{$t('campaignDesigner.contentSelectionAndTag.itemDescription')}}</div>
            </th>
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.quantity')">{{$t('campaignDesigner.contentSelectionAndTag.quantity')}}</div>
            </th>
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.offerType')">{{$t('campaignDesigner.contentSelectionAndTag.offerType')}}</div>
            </th>
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.priceValue')">{{$t('campaignDesigner.contentSelectionAndTag.priceValue')}}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, itemIndex) in offer.itemsList" :key="itemIndex">
            <td v-if="showStatus(itemIndex) && item.status && item.status.length" :rowspan="getBundleSize(item)">{{ $t(`churnScore.${item.status}`) }}</td>
            <td v-else-if="!item.status">&nbsp;</td>
            <td>{{item.itemDescription}}</td>
            <td>{{item.itemTypeDescription}}</td>
            <td>{{item.quantity | localizedNumber($store.getters['session/locale'])}}</td>
            <td>{{item.offerType}}</td>
            <td>{{item.priceValue}}</td>
          </tr>
        </tbody>
      </table>
      <table class="slds-table slds-no-row-hover" :key="`offer_${index}`" v-else>
        <thead>
          <tr scope="col">
            <th scope="col">
              <div class="slds-truncate">&nbsp;</div>
            </th>
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.offerType')">{{$t('campaignDesigner.contentSelectionAndTag.offerType')}}</div>
            </th>
            <th scope="col">
              <div class="slds-truncate" :title="$t('campaignDesigner.contentSelectionAndTag.priceValue')">{{$t('campaignDesigner.contentSelectionAndTag.priceValue')}}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{$t('campaignDesigner.contentSelectionAndTag.flatOffer')}}</td>
            <td>{{offer.offerType}}</td>
            <td>{{offer.priceValue}}</td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
<script>
export default {
  methods: {
    getBundleSize (item) {
      return this.offer.itemsList.filter(i => i.status === item.status).length
    },
    showBundlePrice () {
      return !!this.offer.priceValue && !!this.offer.offerType
    },
    showItemPrice (itemIndex) {
      return !this.showBundlePrice() && !!this.offer.itemsList[itemIndex].priceValue && !!this.offer.itemsList[itemIndex].offerType
    },
    showStatus (index) {
      return index == 0 || this.offer.itemsList[index - 1].status !== this.offer.itemsList[index].status
    }
  },
  props: {
    offer: Object,
    index: Number,
    show: Boolean
  }
}
</script>
<style lang="scss" scoped>
  table {
    border-top: 0px;
  }

  th {
    background-color: #4485C6 !important;
    color: white !important;
  }
</style>
